export var zhCN = {
  common: {
    confrim: '是',
    cancel: '否',
    pleaseSelect: '请选择',
    pleaseInput: '请输入',
    copyrights: 'Powered by Co-Mall'
  },
  components: {
    Auth: {
      login: '登录'
    },
    RichText: {
      tooltips: {
        header: '标题',
        bold: '粗体',
        italic: '斜体',
        underline: '下划线',
        strike: '删除线',
        blockquote: '引用',
        size: '字号',
        header1: '标题1',
        header2: '标题2',
        listordered: '有序列表',
        listbullet: '无序列表',
        scriptsub: '下标',
        scriptsuper: '上标',
        directionrtl: '文本方向',
        color: '颜色',
        background: '背景色',
        font: '字体',
        align: '对齐方式',
        link: '链接',
        image: '图片',
        video: '视频',
        clean: '清除样式',
        'indent-1': '退回缩进',
        'indent+1': '缩进',
        'code-block': '代码块'
      }
    },
    DetailView: {
      back: '返回'
    },
    Button: {
      search: '搜索',
      export: '导出',
      cancel: '取消',
      modify: '修改',
      create: '创建',
      view: '查看',
      submit: '提交',
      delete: '删除',
      save: '保存',
      select: '选择',
      reset: '重置'
    },
    Table: {
      ActionColumn: {
        view: '查看',
        modify: '修改',
        delete: '删除',
        link: '链接'
      },
      selected: '已选择',
      loaded: '已加载'
    },
    Form: {
      required: '不能为空'
    },
    DateRangePicker: {
      placeholder: {
        start: '开始日期',
        end: '结束日期'
      }
    },
    DateTimeRangePicker: {
      placeholder: {
        start: '开始时间',
        end: '结束时间'
      }
    },
    MonthRangePicker: {
      placeholder: {
        start: '开始月份',
        end: '结束月份'
      }
    },
    TimeRangePicker: {
      placeholder: {
        start: '开始时间',
        end: '结束时间'
      }
    },
    UploadFile: {
      moveRight: '右移',
      moveLeft: '左移',
      toUpload: '点击上传',
      dragToUpload: '点击或者拖拽文件到该区域进行上传',
      upload: '上传',
      uploadCompleteMessage: '上传成功{{success}}个，上传失败{{error}}个',
      uploadLimitSizeErrorMessage: '超出上传大小限制，上传失败',
      uploadLimitErrorMessage: '一次最多只能上传{{maxCount}}张图片',
      uploadLimitText: '最多上传',
      uploadLimitUnit: '张',
      preview: '预览'
    }
  },
  routers: {},
  loader: {},
  type: {
    arrayTreeNodeTree: {
      label: '记录',
      sum: '总计'
    }
  },
  error: {
    requestFailed: '请求失败',
    requestTerminated: '请求已被终止。'
  },
  validation: {
    number: {
      default: '请输入合法的数字',
      integer: '请输入合法的整数',
      positive: '请输入合法的正数',
      price: '请输入合法的价格'
    },
    array: {
      default: '请输入合法的数组'
    },
    boolean: {
      default: '请输入合法的布尔值'
    },
    object: {
      default: '请输入合法的对象'
    },
    string: {
      default: '请输入合法的字符串'
    }
  }
};